import { render } from "./ImageHolder.vue?vue&type=template&id=466e0a84&scoped=true&ts=true"
import script from "./ImageHolder.vue?vue&type=script&lang=ts"
export * from "./ImageHolder.vue?vue&type=script&lang=ts"

import "./ImageHolder.vue?vue&type=style&index=0&id=466e0a84&scoped=true&lang=css"

import exportComponent from "/Users/nhonnguyen/Documents/exoty/frontend/exoty-backoffice-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-466e0a84"]])

export default __exports__